export default {
  get: function () {
    let model = {
      'BusinessUnitId': {
        label: '_'
      },

      '*BusinessUnitName': {
        label: 'Business Unit',
        width: 30,
        editable: true
      }
    }

    return model
  }
}



// WEBPACK FOOTER //
// ./src/components/_modules/BusinessUnitsAndCostCenters/BU-list/BUModel.js